<ng-template #template let-total> {{'Common.Total' | translate}} {{ total }} {{isPlural(total, 'Common.Item') | translate }} </ng-template>